window.theme = window.theme || {};

/*
  Reusable helper for reacting to the visitor's Weglot language, since Weglot
  translates client-side and never changes Shopify's own request.locale.

  Usage:
    theme.weglot.onLanguage(function (lang) {
      // runs once with the current language as soon as it's known,
      // and again every time the visitor switches language
    });
*/
theme.weglot = {
  callbacks: [],
  currentLang: null,
  initialized: false,

  onLanguage: function (callback) {
    if (typeof callback !== 'function') return;
    this.callbacks.push(callback);
    if (this.currentLang) {
      callback(this.currentLang);
    }
    this._init();
  },

  _init: function () {
    if (this.initialized) return;
    this.initialized = true;

    var self = this;

    function bind() {
      self._notify(window.Weglot.getCurrentLang());
      window.Weglot.on('languageChanged', function (newLang) {
        self._notify(newLang);
      });
    }

    if (window.Weglot && window.Weglot.initialized) {
      bind();
      return;
    }

    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (window.Weglot) {
        clearInterval(poll);
        if (window.Weglot.initialized) {
          bind();
        } else {
          window.Weglot.on('initialized', bind);
        }
      } else if (attempts > 100) {
        clearInterval(poll);
      }
    }, 100);
  },

  _notify: function (lang) {
    this.currentLang = lang;
    this.callbacks.forEach(function (cb) {
      cb(lang);
    });
  }
};
